export const TRAINING_RUNS_BASE_URL =
  'https://storage.googleapis.com/moveo-dev-vertex-training/training-runs/';

/**
 * How long a plan usually runs for, by plan name. Picking a plan in the subscription
 * editor pre-fills the end date with this — it is a starting point, not a rule, and the
 * operator can pick any other term or a custom date.
 *
 * `null` means the plan does not expire by default (the legacy free plan, and anything
 * we have not dated).
 */
export const PLAN_DEFAULT_TERM_MONTHS = {
  scan: 1, // 30 days — the self-serve readiness scan
  pilot: 3, // the pilot is sold as three months
  growth: 12, // annual
  scale: 12, // annual
  'free plan': null, // never expires
  free: null,
};

/** Terms offered in the duration picker. */
export const PLAN_TERM_OPTIONS = [
  { value: 1, label: '1 month' },
  { value: 2, label: '2 months' },
  { value: 3, label: '3 months' },
  { value: 6, label: '6 months' },
  { value: 12, label: '1 year' },
  { value: 24, label: '2 years' },
  { value: 0, label: 'No expiry' },
];
